import nugz from '~/images/AiModule/nugz.png';
import orth from '~/images/AiModule/orth.png';

export enum AiAgentEnum {
  Orth = 'orth', // agronomist
  Nugz = 'nugz', // bulk upload
}

export const agents = [
  {
    name: AiAgentEnum.Orth,
    imgSrc: orth,
    description: 'orth-title',
    subDescription: 'orth-subtitle',
  },
  {
    name: AiAgentEnum.Nugz,
    imgSrc: nugz,
    description: 'nugz-title',
    subDescription: 'nugz-subtitle',
  },
];

export const supportedFiles = {
  'application/pdf': ['.pdf'],
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
  //   '.docx',
  // ],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'text/csv': ['.csv'],
  'text/markdown': ['.md'],
  'text/plain': ['.txt'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

export enum ConversationTag {
  Genral = 'General',
  Field = 'Field',
}

export const containerHeight = 'h-[70vh]';

export const orthSuggestedMessages = [
  {
    message: 'orth-suggest-message-1',
    files: [],
  },
  {
    message: 'orth-suggest-message-2',
    files: [],
  },
  {
    message: 'orth-suggest-message-3',
    files: [],
  },
];

export const gradientStyle = {
  border: '1px solid transparent',
  background: `linear-gradient(135deg, rgba(230, 100, 101, 1), rgba(230, 100, 101, 0)) padding-box,
              linear-gradient(135deg, #3432c7 0%, #b632c7 100%) border-box
              `,
};
